const greys = {
  1: { main: '#FFFFFF', font: '#000000' },
  2: { main: '#F8F9FB', font: '#000000' },
  3: { main: '#9B9B9B', font: '#000000' },
  4: { main: '#353535', font: '#000000' },
  10: { main: '#000000', font: '#FFFFFF' },
};

export default greys;
